export const getCity = (cities = [], cityName) => {
	if (!cities) return;
	return cities.find((c) => c.name === cityName);
};
